export const initialState = {
  values: [],
  changed: false
};

export function reducer(state, action) {
  switch (action.type) {
    case 'OnInitState':
      return onInitState(state, action);
    case 'OnReqDocTypePropertyChanged':
      return onReqDocTypePropertyChanged(state, action);
    case 'OnReqDocTypePropertyAdded':
      return onReqDocTypePropertyAdded(state, action);
    case 'OnReqDocTypePropertyUpdated':
      return onReqDocTypePropertyUpdated(state, action);
    case 'OnReqDocTypePropertyDelete':
      return onReqDocTypePropertyDelete(state, action);
    default:
      return state;
  }
}

function onInitState(state, action) {
  const { data } = action;
  return {
    ...state,
    values: data,
    changed: false
  };
}

function onReqDocTypePropertyChanged(state, action) {
  const { propName, propValue, index } = action;
  return {
    ...state,
    values: Object.assign([...state.values], {
      [index]: {
        ...state.values[index],
        [propName]: propValue
      }
    }),
    changed: true
  };
}

function onReqDocTypePropertyAdded(state, action) {
  const newProperty = {
    propertyId: '',
    defaultValue: '',
    mandatory: false,
    requiredDocTypeId: action.reqDocTypeId
  };
  const requiredDocTypeProperties = state.values ? Object.assign([...state.values]) : [];
  requiredDocTypeProperties.push({ ...newProperty });
  return {
    ...state,
    values: requiredDocTypeProperties,
    changed: true
  };
}

function onReqDocTypePropertyUpdated(state, _action) {
  return {
    ...state,
    changed: false
  };
}

function onReqDocTypePropertyDelete(state, action) {
  const { index } = action;
  const newProperties = Object.assign([...state.values]);
  newProperties.splice(index, 1);
  return {
    ...state,
    values: newProperties,
    changed: true
  };
}
